import { george, observer, pr, React, theme, ui } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import trackingStore from "stores/TrackingStore";
import { safeWindowOpen } from "util/helpers";
import { JuniorChild } from "./components/cards/JuniorChild";
import { NoContentCard } from "./components/cards/NoContentCard";
import { JuniorRoutes } from "./JuniorRoutes";
import { JuniorStore } from "./JuniorStore";

type IProps = {
    store: JuniorStore;
};

//handleHandover not used here for now, wait until EB has finally tested this feature and then delete it if not needed
// const getHandoverUrl = (offer?: IOffer) => {
//     const initialHandoverUrl = offer?.handover?.url;

//     if (!initialHandoverUrl) {
//         return;
//     }

//     const stateObject: IDeeplinkState = {
//         srcClientId: externalInterfaceStore.clientId,
//         returnState: "/overview",
//         redirectUri: externalInterfaceStore.georgeBaseUrl + "/?at=c"
//     };

//     // Base64 encode the state object
//     return `${initialHandoverUrl}${initialHandoverUrl.includes("?") ? "&" : "?"}state=${btoa(JSON.stringify(stateObject))}`;
// };


export const JuniorOverview = observer(({ store }: IProps) => {
    const ref = React.useRef<HTMLAnchorElement | null>(null);
    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;

    const BackgroundComponent = externalInterfaceStore.isGeorgeApp ? george.Background : george.BackgroundWithNavBar;

    //handleHandover not used here for now, wait until EB has finally tested this feature and then delete it if not needed
    // const handleHandover = async () => {
    //     const url = getHandoverUrl(store.gJuniorOffers?.[0]);
    //     if (!url) {
    //         pushRoute("/error");
    //         return;
    //     }

    //     const query = parse(url.split("?")[1]);
    //     if (!query.channel) {
    //         // no channel -> cannot determine token exchange clientId
    //         pushRoute("/error");
    //         return;
    //     }

    //     // Info from teams call on 2024-05-08
    //     let clientId = "";
    //     if (query.channel === "09") {
    //         clientId = "INT82482";
    //     } else if (query.channel === "10") {
    //         clientId = "INT824BB";
    //     } else {
    //         // unknown channel
    //         pushRoute("/error");
    //         return;
    //     }

    //     try {
    //         const target = NetbankingAPI.tokenExchange(clientId);
    //         const res = await NetbankingAPIClient.requestType(target);
    //         const accessToken = res.access_token;
    //         const handoverUrl = `${url}#access_token=${accessToken}`;
    //         //console.log("### handoverUrl", handoverUrl);
    //         safeWindowOpen(handoverUrl);
    //     } catch (error) {
    //         pushRoute("/error");
    //     }
    // };


    const handleOnboarding = () => {
        const deeplink = "georgeapp://at/deeplink?path=kids-onboarding";
        const url = `${externalInterfaceStore.georgeBaseUrl}/index.html?crossPlatform=true&at=c#kids-onboarding`;
        safeWindowOpen(
            externalInterfaceStore.isGeorgeApp ?
                deeplink :
                url,
            "_blank"
        );
    };

    const handleChildSelect = (childId: string, customerId: string) => {
        store.selectChild(childId);
        trackingStore.trackEvent({
            eventName: "childSelected",
            productKey: "FAMILYCORNER",
            data: {
                detailsKey1: "childCustomerID",
                detailsValue1: customerId,
            }
        });
        pushRoute(JuniorRoutes.DETAIL);
    };

    if (store.isLoading) {
        return (
            <BackgroundComponent>
                <george.LoadingIndicator isLoading={store.isLoading} height={ui.windowHeight} />
            </BackgroundComponent>
        );
    }

    return (

        <BackgroundComponent style={{ paddingTop: theme.MARGIN, paddingBottom: theme.MARGIN }}>

            <george.PageWithActionButton>
                <div style={{ ...pr.STYLE_CENTERED_CARD, marginBottom: theme.MARGIN_SMALL }}>
                    <pr.P_24_TITLE
                        style={{
                            fontWeight: 700,
                            marginTop: theme.MARGIN,
                        }}
                    >
                        {ui.__("gJunior.existingKids.title")}
                    </pr.P_24_TITLE>
                    <pr.P_16_CONTENT
                        style={{
                            lineHeight: "22px",
                            marginTop: 16,
                        }}
                    >
                        {ui.__("gJunior.existingKids.text")}
                    </pr.P_16_CONTENT>
                </div>

                {store.children.length > 0 ? (
                    <george.Card
                        style={{ borderRadius: 8, overflow: "hidden" }}
                    >
                        {store.children.map((child, index) => (
                            <div key={child.id}>
                                <JuniorChild
                                    name={child.name}
                                    juniorValue={child.juniorValue}
                                    gender={child.gender}
                                    onClick={() => handleChildSelect(child.id, child.customerId)}
                                    isLast={index === store.children.length - 1}
                                />
                            </div>
                        ))}
                    </george.Card>
                ) : (
                    <NoContentCard description={ui.__("gJunior.noChildren.description")} imgSrc={require("../../assets/gJunior/info_circle.svg")} />
                )}

                <div style={{ ...pr.STYLE_CENTERED_CARD }}>
                    <pr.P_18_TITLE
                        style={{
                            fontWeight: 600,
                            marginTop: theme.MARGIN,
                        }}
                    >
                        {ui.__("gJunior.newChild.title")}
                    </pr.P_18_TITLE>
                </div>

                <george.Card
                    elevated={false}
                    style={{ borderRadius: 8, padding: theme.MARGIN, textAlign: "center" }}
                >

                    <img
                        src={require("../../assets/add_new_child.svg")}
                        height={"100px"}
                        alt="George Junior icon"
                    />

                    <pr.P_14_CONTENT
                        style={{
                            marginTop: theme.MARGIN,
                        }}
                    >
                        {ui.__("gJunior.newChild.text")}
                    </pr.P_14_CONTENT>

                    <GdsFakeActionButton
                        style={{
                            marginTop: theme.MARGIN,
                            borderRadius: theme.BORDER_RADIUS_FULL,
                        }}
                        color="primary"
                        fullWidth={isMobile}
                        onClick={handleOnboarding}
                    >
                        {ui.__("gJunior.newChild.button")}
                    </GdsFakeActionButton>

                </george.Card>

            </george.PageWithActionButton>
        </BackgroundComponent >
    );
});



// WEBPACK FOOTER //
// ./src/components/gJunior/JuniorOverview.tsx